import {AsyncPipe, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {TranslateModule} from '@ngx-translate/core';
import {TextCutterPipe} from '../../shared/pipes/text-cutter.pipe';
import {DiagramUserDetailsComponent} from './user-details/diagram-user-details.component';
import {MapDaoService} from '../../../core/map/map-dao.service';
import {IconButtonComponent} from '@q9elements/ui-kit/components';
import {MatDividerModule} from '@angular/material/divider';
import {Q9HtmlDecoderPipe, Q9TrackDirective} from '@q9elements/ui-kit/common';

@Component({
  selector: 'app-diagram-details',
  templateUrl: './diagram-details.component.html',
  styleUrls: ['./diagram-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatIconModule,
    DiagramUserDetailsComponent,
    NgIf,
    TextCutterPipe,
    TranslateModule,
    Q9HtmlDecoderPipe,
    Q9TrackDirective,
    IconButtonComponent,
    MatDividerModule
  ]
})
export class DiagramDetailsComponent {
  @Input() generationInProgress: boolean;
  @Input()
  set diagramData(data: any) {
    if (this._diagramData?.id === data?.id || this.generationInProgress) {
      this._diagramData = data;

      return;
    }

    this._diagramData = data;

    // prevent fetch of map user on every update of the diagram content as it doesn't make sense
    // @todo: consider moving mapOwner information to firebase json like it's done for other important types of users?
    if (data && data.map) {
      this.mapOwner$ = this.mapDaoService
        .getMapUsers(data.map.id)
        .pipe(map(response => response.mapOwner));
    }
  }

  private _diagramData: any;
  get diagramData() {
    return this._diagramData;
  }
  mapOwner$: Observable<any>;

  constructor(private mapDaoService: MapDaoService) {}
}
